// JOBE-0163.1 — DepartmentPage: W4 department drill-down.
// Route: /department/:slug
// Framing picker drives ?framing=<key>; default is okrs.
// Data is mock-only in v1 behind wcc.mock.departments flag.

import { useParams, useSearchParams } from 'react-router-dom';
import { useFlag }        from '../lib/useFlagStore.js';
import { useDrillContext } from '../lib/drillContext.js';
import { PillChip }       from '../components/PillChip/PillChip.jsx';
import { wccDepartmentDetail } from '../mock-wcc.js';
import GoalsFraming       from './GoalsFraming.jsx';
import OkrsFraming        from './OkrsFraming.jsx';
import KpisFraming        from './KpisFraming.jsx';
import ScorecardFraming   from './ScorecardFraming.jsx';
import './DepartmentPage.css';

const FRAMINGS = [
  { key: 'goals',     label: 'Goals' },
  { key: 'okrs',      label: 'OKRs' },
  { key: 'kpis',      label: 'KPIs' },
  { key: 'scorecard', label: 'Scorecard' },
];

const FRAMING_COMPONENTS = {
  goals:     GoalsFraming,
  okrs:      OkrsFraming,
  kpis:      KpisFraming,
  scorecard: ScorecardFraming,
};

export default function DepartmentPage() {
  const { slug }                        = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const drillCtx                        = useDrillContext();
  const mockEnabled                     = useFlag('wcc.mock.departments');

  // Default framing: okrs
  const activeFraming = FRAMINGS.find(f => f.key === searchParams.get('framing'))
    ?? FRAMINGS.find(f => f.key === 'okrs');

  // Real fetch is backlog; v1 is mock-only.
  const dept = mockEnabled ? wccDepartmentDetail[slug] : null;

  if (!dept) return <div className="dept-not-found">Department not found.</div>;

  const ActiveComponent = FRAMING_COMPONENTS[activeFraming.key];

  function setFraming(key) {
    setSearchParams(prev => { prev.set('framing', key); return prev; });
  }

  return (
    <div className="department-page">
      {drillCtx && (
        <nav className="drill-breadcrumb" aria-label="drill context">
          ← {drillCtx.label}
        </nav>
      )}
      <header className="dept-header">
        <h1 className="dept-name">{dept.displayName}</h1>
        <span className="dept-member-counts">
          {dept.memberCount.humans} humans · {dept.memberCount.agents} agents
        </span>
        <div className="framing-picker" role="group" aria-label="framing">
          {FRAMINGS.map(f => (
            <PillChip
              key={f.key}
              label={f.label}
              active={f.key === activeFraming.key}
              onClick={() => setFraming(f.key)}
            />
          ))}
        </div>
      </header>
      <main className="dept-content">
        <ActiveComponent dept={dept} />
      </main>
    </div>
  );
}
